import { useTranslation } from 'react-i18next';
import { TextSearchField } from '@anytag/shared-molecules';
import { Button, Form } from '@anytag/shared-atoms';

interface TemplateProps {
  onSubmit?: () => void;
  loading: boolean;
}

export const Template = ({ onSubmit, loading }: TemplateProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <TextSearchField name="keyword" onSubmit={onSubmit} placeholder={t<string>('Search.UserFilter')} />

      <Form.Field className="flex-none">
        <Button variant="outline" title={t('Button.Search')} loading={loading} className="w-33" />
      </Form.Field>
    </Form.Fields>
  );
};
